export default "__VITE_ASSET__hOjlfOJT__"